import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  forwardRef,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import Papa from 'papaparse';
import { PalantirAvatarComponent } from '../../../avatar/avatar.component';
import { PalantirButtonComponent } from '../../../button/button.component';
import { PalantirIconComponent } from '../../../icon/icon.component';
import { PalantirModalComponent } from '../../../modal/modal.component';
import { PalantirTextComponent } from '../../../text/text.component';
import { PalantirToolbarComponent } from '../../../toolbar/toolbar.component';
import { FxDynamicTabularComponent } from '../../dynamic-tabular.component';
import { FxDynamicTabularComponentConfig } from '../../dynamic-tabular.type';

export interface FxDynamicTabularDialogData {
  control: FormControl<string[][]>;
  readonly: boolean;
  schema: FxDynamicTabularComponentConfig | null;
}

@Component({
  selector: 'fx-dynamic-tabular-dialog',
  imports: [
    forwardRef(() => FxDynamicTabularComponent),
    PalantirModalComponent,
    PalantirToolbarComponent,
    PalantirIconComponent,
    PalantirButtonComponent,
    PalantirTextComponent,
    PalantirAvatarComponent,
  ],
  templateUrl: './dynamic-tabular-dialog.component.html',
  styleUrls: ['./dynamic-tabular-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FxDynamicTabularDialogComponent {
  public readonly data = inject<FxDynamicTabularDialogData>(DIALOG_DATA);

  public readonly dialogRef = inject(DialogRef);

  public exportToCSV() {
    const csv = Papa.unparse(this.data.control.value || []);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    const now = new Date();
    const nowFormat = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
    link.setAttribute('download', `table-data-${nowFormat}.csv`);
    link.style.visibility = 'hidden';
    document.body.append(link);
    link.click();
    link.remove();
  }

  public close() {
    this.dialogRef.close();
  }
}
